export default __webpack_public_path__ + "static/media/share_icon.3d94abbe.svg";